<template>
  <div class="mb-16">
    <CheckoutCancelPaymentModal v-if="!checkoutStore.ivpMode" />
    <CheckoutHeader :current-step="3" />

    <!-- IVP mode: Invoice payment form -->
    <CheckoutLayout
      v-if="checkoutStore.ivpMode"
      next-link="/checkout/payment"
      :title="t('checkout.invoice_payment')"
      :has-discount-code="false"
      :has-gift-card="false"
    >
      <CheckoutInvoiceForm />
    </CheckoutLayout>

    <!-- Payment failed mode (existing behavior) -->
    <CheckoutLayout
      v-else-if="cart.paymentFailedExpire > 0"
      next-link="/checkout/payment"
      :title="t('checkout.payment')"
      :has-discount-code="false"
      :has-gift-card="false"
    >
    </CheckoutLayout>
  </div>
</template>

<script setup lang="ts">
  import { watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { onBeforeRouteLeave } from 'vue-router';
  import { useRouter } from 'vue-router';

  import CheckoutCancelPaymentModal from '@/components/checkout/CheckoutCancelPaymentModal.vue';
  import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
  import CheckoutInvoiceForm from '@/components/checkout/CheckoutInvoiceForm.vue';
  import CheckoutLayout from '@/components/checkout/CheckoutLayout.vue';
  import { useCartStore } from '@/stores/cart';
  import { useCheckoutStore } from '@/stores/checkoutStore';
  import { isEmbed } from '@/utils/isEmbed';
  import { useWebsocketStore } from '@/websocket/websocket';

  const cart = useCartStore();
  const checkoutStore = useCheckoutStore();
  const websocketStore = useWebsocketStore(); // Make sure it is open
  const { t } = useI18n();
  const router = useRouter();

  // Watch paymentFailedTimeoutFlag from cart store
  watch(() => cart.paymentFailedTimeoutFlag, (newValue) => {
    if (newValue) {
      console.log('Payment failed timeout triggered');
      cart.paymentFailedTimeoutFlag = false; // reset the flag
      if (isEmbed()) {
        router.replace({ name: 'checkout-timeout' });
      } else {
        router.push('/');
      }
    }
  });

  //Timeout to check if we need to load a backup unpaid order
  setTimeout(() => {
    if(cart.unpaidOrder.order && cart.unpaidOrder.order.ts == 0) {
      cart.doBackupUnpaidOrder();
    }
  }, 1000);

  onBeforeRouteLeave((to) => {
    // Reset IVP mode when leaving the payment view
    if (checkoutStore.ivpMode) {
      checkoutStore.ivpMode = false;
      // Don't close websocket when navigating to receipt after IVP — the receipt needs it
      if (to.path.includes('/receipt') || to.name === 'checkout-receipt') {
        return;
      }
    }
    websocketStore.close();
  });

</script>
